import type { AxiosError, AxiosResponse } from 'axios'
import {
  getStrategyData,
  postStrategyData,
  deleteStrategy,
  fetchPredefinedGroups,
  fetchStrategyById,
  postEditedStrategyData,
  statusEditMStrategy,
  fetchPositionById,
  fetchBasketById,
  executeBasketOrderById,
  forceRebalanceById,
  cancelBasketOrderById,
  sellPosition,
  getMargin,
  fetchMySystemBuilder,
  fetchPublicSystemBuilder,
  fetchMyGroups,
  fetchPredefinedSystemBuilder,
  logoutSession,
  fetchRadarData,
  addPositions,
  addMultiplePositions,
  checkPortfolioStatus,
  markAsSellPosition,
  fetchClosedPositionById,
  calculateRealizedAndUnRealizedPNL,
  createStrategyCopy,
  fetchStrategyNames,
  confirmAdjustHoldings,
  confirmAdjustClosedPositions,
  fetchLogData,
  fetchAuditLogData,
  fetchPopularStrategyNames,
  fetchPopularStrategiesByCategory,
  fetchTopPerformerStrategies,
  fetchPopularStrategyDataid,
  fetchHsToken,
  fetchNseSector,
  fetchNseRate,
  fetchTradeBasketById,
  forceRebalanceTradeBasket,
  executeBasketTrades,
  fetchFromConfigTable,
  postTradeStrategyData,
  fetchTradeStrategyById,
  postTradeEditedStrategyData,
  fetchTradeStrategyNames,
  fetchMFStrategyNames,
  deleteTradeStrategy,
  fetchTradePositionById,
  fetchTradeClosedPositionById,
  checkTradePortfolioStatus,
  calculateTradeRealizedAndUnRealizedPNL,
  sellTradePosition,
  markAsSellTradePosition,
  confirmAdjustTradeHoldings,
  confirmAdjustTradeClosedPositions,
  addTradePositions,
  addMultipleTradePositions,
  fetchTradeStrategyData,
  calculateCurrentValue,
  fetchPoaStatus,
  fetchNSESymbolsCron,
  fetchTradingPopularStrategyNames,
  fetchTPopularStrategyById,
  saveMFStrategyData,
  fetchMFStrategyData,
  fetchMFBasketById,
  forceRebalanceMFBasket,
  executeMFBasketTrades,
  fetchMFStrategyById,
  postEditedMFStrategyData,
  deleteMFStrategy,
  setPlanPref,
  checkPlanPref,
  fetchMFPositionById,
  sellMFPosition,
  fetchMFPopularStrategyNames,
  fetchMFPopularStrategyById,
  getScannersList,
  cancelTradeBasketOrderById,
  fetchStrategyFromCode,
  fetchStrategyNameFromCode,
  getSimulatorResult,
  eSign,
  getBacktestingResult,
  checkForValidRole,
  fetchWPMomentumAll,
  fetchWPStrategies,
  getHoldings,
  fetchBBStrategies,
  fetchBlackboxStrategyDataById,
  fetchAllBBStrategies,
  deployBBStrategy,
  updateBBStrategy,
  validateBlackboxStrategyDataById,
  deleteBBStrategy,
  fetchSymbolsDataCronWithBe,
  fetchMmmScore,
  fetchAvailableTags
} from '@/services/momentumService'
import type {
  AddPosition,
  AdjustPosition,
  AuditLogResponse,
  BacktestingPayload,
  BackTestResult,
  Basket,
  BBDeploymentPayload,
  BbStrategyDetailsDto,
  BBStrategyResponse,
  BBStrategyResponseById,
  CachedStrategyItem,
  CombinedOrderResponse,
  FilteredScannerList,
  GroupResponse,
  HsTokenResponse,
  IHolding,
  IHoldingsApiItem,
  IHoldingsApiResponse,
  LogResponse,
  MFBasket,
  MFOrderStatus,
  MFPositionScheme,
  MFResponse,
  MmmScoreGrouped,
  MutualFundDetails,
  NseSectorResponse,
  PlanPrefSet,
  PnlResponse,
  PopularStrategyResponse,
  PortfolioResponse,
  Positions,
  PredefinedSystemBuilder,
  ScannerList,
  SellPositionsResponse,
  SimulatorPayload,
  SimulatorResponse,
  StrategyDetails,
  TradeBasket,
  UpdateBbStrategyDto,
  WpPost
} from './types'
import { defineStore } from 'pinia'
import router from '@/router'
export const useStrategyStore = defineStore({
  id: 'strategyStore',
  state: () => ({
    error: {
      message: ''
    },
    tempStrategyData: {} as StrategyDetails,
    tempMFStrategyData: {} as MutualFundDetails,
    getStrategyData: {} as StrategyDetails[],
    getTradeStrategyData: {} as StrategyDetails[],
    getMFStrategyData: {} as MutualFundDetails[],
    getStrategyDataById: {} as StrategyDetails | null,
    getMFStrategyDataById: {} as MutualFundDetails | null,
    getTradeStrategyDataById: {} as StrategyDetails[] | [],
    getPopularStrategyDataById: {} as StrategyDetails[] | [],
    getTradePopularStrategyDataById: {} as StrategyDetails[] | [],
    getMFPopularStrategyDataById: {} as MutualFundDetails | null,
    NSEGroups: {} as string[],
    FNOGroups: {} as string[],
    BSEGroups: {} as string[],
    CURGroups: {} as string[],
    BFOGroups: {} as string[],
    MCXGroups: {} as string[],
    symbolsData: {} as string[],
    groupsData: {} as string[],
    myGroupData: {} as string[],
    mySystemBuilder: {} as PredefinedSystemBuilder[],
    publicSystemBuilder: {} as PredefinedSystemBuilder[],
    predefinedSystemBuilder: {} as PredefinedSystemBuilder[],
    getPositionsById: {} as Positions[],
    getMFPositionsById: {} as MFPositionScheme[],
    getMFSchemes: {} as string[],
    closedPositionsById: {} as Positions[],
    getTradePositionsById: {} as Positions[],
    closedTradePositionsById: {} as Positions[],
    getBasketById: {} as Basket[],
    tradeBasket: {} as TradeBasket[],
    mfBasket: {} as MFBasket[],
    editId: 0,
    savedStrategyResponse: '',
    savedBBResponse: '',
    showModal: false,
    errorModal: false,
    esignModal: false,
    getLTP: 0,
    orderBookStatus: {} as CombinedOrderResponse,
    mfStatus: {} as MFOrderStatus,
    mfMessage: '' as string,
    positionBookStatus: {} as SellPositionsResponse,
    executeBasketStatus: '',
    basketMargin: '',
    radarGroupData: {} as GroupResponse,
    isBasketVirtual: 0 as number | undefined,
    InProgress: 0 as number | undefined,
    TradeInProgress: 0 as number | undefined,
    DaysLeft: 0 as number | undefined,
    isSipAmount: false as boolean | undefined,
    ADDEDSIPAMT: 0 as number | undefined,
    ExecStrat: false as boolean | undefined,
    TradeExecStrat: false as boolean | undefined,
    Status: 0 as number | undefined,
    portfolioResponse: {} as PortfolioResponse,
    tradePortfolioResponse: {} as PortfolioResponse,
    pnlResponse: {} as PnlResponse,
    tradePnlResponse: {} as PnlResponse,
    strategyNames: {} as string[],
    tradeStrategyNames: {} as string[],
    mfStrategyNames: {} as string[],
    etfGroup: '' as string,
    planPref: {} as PlanPrefSet,
    popularStrategyNames: [] as PopularStrategyResponse[],
    popularTradeStrategyNames: [] as PopularStrategyResponse[],
    popularMFStrategyNames: [] as PopularStrategyResponse[],
    categoryStrategies: [] as PopularStrategyResponse[],
    categoryLoading: false as boolean,
    topPerformerStrategies: [] as PopularStrategyResponse[],
    topPerformerLoading: false as boolean,
    wpMomentumAll: [] as WpPost[],
    wpStrategies: [] as CachedStrategyItem[],
    logs: {} as LogResponse[],
    auditlogs: {} as AuditLogResponse[],
    hsToken: {} as HsTokenResponse,
    nseSectorResponse: {} as NseSectorResponse,
    nseSectorRate: 0,
    currentValue: 0,
    poaStatus: '',
    planPrefSetResponseMessage: '' as string,
    scannersList: {} as ScannerList,
    filteredStrategies: {} as FilteredScannerList[],
    simulatorResult: {} as SimulatorResponse | null,
    backtestResult: [] as BackTestResult[],
    isValidRole: false as boolean,
    holdings: [] as Array<{
      id?: string
      symbol: string
      heldQty: number
      buyPrice: number
      value: number
      maxAvailableQty?: number
    }>,
    holdingsLoading: false as boolean,
    holdingsError: null as string | null,
    getBBStrategyData: {} as BBStrategyResponse[],
    getBBStrategyDataById: {} as BBStrategyResponseById,
    allBBStrategies: {} as BbStrategyDetailsDto[],
    mmmScoreData: {} as MmmScoreGrouped,
    availableTags: [] as string[]
  }),
  getters: {
    getAllBBStrategies(state): BbStrategyDetailsDto[] {
      return state.allBBStrategies
    },
    getBlackboxStrategyData(state): BBStrategyResponse[] {
      return state.getBBStrategyData
    },
    getBlackboxStrategyDataById(state): BBStrategyResponseById {
      return state.getBBStrategyDataById
    },
    getListStrategies(state) {
      return state.filteredStrategies || []
    },
    getListScanners(state) {
      return state.scannersList
    },
    getPoaStatus(state) {
      return state.poaStatus
    },
    getCurrentVaue(state) {
      return state.currentValue
    },
    getEtfGroup(state) {
      return state.etfGroup
    },
    getPlanPref(state) {
      return state.planPref
    },
    getTradeBasketResponse(state) {
      return state.tradeBasket
    },
    getMFBasketResponse(state) {
      return state.mfBasket
    },
    getNseRateResponse(state) {
      return state.nseSectorRate
    },
    getNseSectorResponse(state) {
      return state.nseSectorResponse
    },
    getStrategyNames(state): string[] {
      return state.strategyNames
    },
    getTradeStrategyNames(state): string[] {
      return state.tradeStrategyNames
    },
    getMFStrategyNames(state): string[] {
      return state.mfStrategyNames
    },
    getPopularStrategyNames(state) {
      return state.popularStrategyNames
    },
    getCategoryStrategies(state) {
      return state.categoryStrategies
    },
    getTopPerformerStrategies(state) {
      return state.topPerformerStrategies
    },
    getPopularTradeStrategyNames(state) {
      return state.popularTradeStrategyNames
    },
    getPopularMFStrategyNames(state) {
      return state.popularMFStrategyNames
    },
    getWPMomentumAll(state) {
      return state.wpMomentumAll
    },
    getWPStrategies(state) {
      return state.wpStrategies
    },
    getPNLResponse(state): PnlResponse {
      return state.pnlResponse
    },
    getTradePNLResponse(state): PnlResponse {
      return state.tradePnlResponse
    },

    getPortfolioResponse(state): PortfolioResponse {
      return state.portfolioResponse
    },
    getTradePortfolioResponse(state): PortfolioResponse {
      return state.tradePortfolioResponse
    },
    getStrategyDataMap(state): StrategyDetails[] {
      return state.getStrategyData
    },
    getTradingStrategyDataMap(state): StrategyDetails[] {
      return state.getTradeStrategyData
    },
    getMFStrategyDataMap(state): MutualFundDetails[] {
      return state.getMFStrategyData
    },
    getStrategyDataMapById(state): StrategyDetails | null {
      return state.getStrategyDataById
    },
    getMFStrategyDataMapById(state): MutualFundDetails | null {
      return state.getMFStrategyDataById
    },
    getTradeStrategyDataMapById(state): StrategyDetails[] | [] {
      return state.getTradeStrategyDataById
    },
    getPopularStrategyDataMapById(state): StrategyDetails[] | [] {
      return state.getPopularStrategyDataById
    },
    getTradePopularStrategyDataMapById(state): StrategyDetails[] | [] {
      return state.getTradePopularStrategyDataById
    },
    getMFPopularStrategyDataMapById(state): MutualFundDetails | null {
      return state.getMFPopularStrategyDataById
    },
    getNSEGroups(state): string[] {
      return state.NSEGroups
    },
    getFNOGroups(state): string[] {
      return state.FNOGroups
    },
    getBSEGroups(state): string[] {
      return state.BSEGroups
    },
    getCURGroups(state): string[] {
      return state.CURGroups
    },
    getBFOGroups(state): string[] {
      return state.BFOGroups
    },
    getMCXGroups(state): string[] {
      return state.MCXGroups
    },
    getSymbolsData(state): string[] {
      return state.symbolsData
    },
    getGroupsData(state): string[] {
      return state.groupsData
    },
    getMyGroupsData(state): string[] {
      return state.myGroupData
    },
    getRadarData(state): GroupResponse {
      return state.radarGroupData
    },
    getMySystemBuilders(state): PredefinedSystemBuilder[] {
      return state.mySystemBuilder
    },
    getPublicSystemBuilders(state): PredefinedSystemBuilder[] {
      return state.publicSystemBuilder
    },
    getPredefinedSystemBuilders(state): PredefinedSystemBuilder[] {
      return state.predefinedSystemBuilder
    },
    getPositionsDataById(state): Positions[] {
      return state.getPositionsById
    },
    getMFPositionsDataById(state): MFPositionScheme[] {
      return state.getMFPositionsById
    },
    getMFSchemeNames(state) {
      return state.getMFSchemes
    },
    getClosedPositionsById(state): Positions[] {
      return state.closedPositionsById
    },
    getTradePositionsDataById(state): Positions[] {
      return state.getTradePositionsById
    },
    getClosedTradePositionsById(state): Positions[] {
      return state.closedTradePositionsById
    },
    getEditId(state) {
      return state.editId
    },
    getSavedStrategyResponse(state) {
      return state.savedStrategyResponse
    },
    getResponseModalData(state) {
      return state.showModal
    },
    getErrorModal(state) {
      return state.errorModal
    },
    getEsignModal(state) {
      return state.esignModal
    },
    getBasketDataById(state) {
      return state.getBasketById
    },
    getBasketVirtualStatus(state) {
      return state.isBasketVirtual
    },
    getRebalanceStatus(state) {
      return state.InProgress
    },
    getTradeRebalanceStatus(state) {
      return state.TradeInProgress
    },
    getNoOfDaysLeft(state) {
      return state.DaysLeft
    },
    getExecStrat(state) {
      return state.ExecStrat
    },
    getTradeExecStrat(state) {
      return state.TradeExecStrat
    },
    getStatus(state) {
      return state.Status
    },
    getSipStatus(state) {
      return state.isSipAmount
    },
    getAddedSipAmt(state) {
      return state.ADDEDSIPAMT
    },
    getLTPforPositions(state) {
      return state.getLTP
    },
    getExecuteBasketStatus(state) {
      return state.executeBasketStatus
    },
    getOrderBookStatus(state) {
      return state.orderBookStatus
    },
    getMFOrderStatus(state) {
      return state.mfMessage
    },
    getPositionBookStatus(state) {
      return state.positionBookStatus
    },
    getBasketMargin(state) {
      return state.basketMargin
    },
    getLogs(state) {
      return state.logs
    },
    getAuditLogs(state) {
      return state.auditlogs
    },
    getHsToken(state) {
      return state.hsToken
    },

    getMFStatus(state) {
      return state.mfStatus
    },
    getIsValidRole(state) {
      return state.isValidRole
    },
    getHoldings(state) {
      return state.holdings
    },
    getHoldingsLoading(state) {
      return state.holdingsLoading
    },
    getHoldingsError(state) {
      return state.holdingsError
    },
    getMmmScoreData(state): MmmScoreGrouped {
      return state.mmmScoreData
    },
    getAvailableTags(state): string[] {
      return state.availableTags
    }
  },
  actions: {
    closeIsValidRoleModal() {
      this.isValidRole = false
    },
    setUserPlanPref(planPref: string) {
      setPlanPref(planPref)
        .then(({ data }: AxiosResponse) => {
          this.planPrefSetResponseMessage = data?.pref
        })
        .catch((error) => {
          if (error.response) {
            console.error('Error response:', error.response.data)
            console.error('Status code:', error.response.status)
          } else if (error.request) {
            console.error('No response received')
          } else {
            console.log(error)
          }
        })
    },
    fetchStrategyData(): Promise<void> {
      return getStrategyData()
        .then((response: AxiosResponse) => {
          console.log('response.data', response.data)

          this.getStrategyData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchTradeStrategyData(): Promise<void> {
      return fetchTradeStrategyData()
        .then((response: AxiosResponse) => {
          this.getTradeStrategyData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchMFStrategyData(): Promise<void> {
      return fetchMFStrategyData()
        .then((response: AxiosResponse) => {
          console.log('respo', response.data)

          this.getMFStrategyData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
          throw error
        })
    },
    saveStrategyDataTemp(strategyDetails: StrategyDetails): Promise<void> {
      return postStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.data
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    deployBB(strategyDetails: BBDeploymentPayload): Promise<void> {
      return deployBBStrategy(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedBBResponse = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    updateBBStrategy(strategyDetails: UpdateBbStrategyDto): Promise<void> {
      return updateBBStrategy(strategyDetails)
        .then((response: AxiosResponse) => {
          this.fetchAllBBStrategies()
          this.savedStrategyResponse = response?.data?.message
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    saveTradeStrategyDataTemp(strategyDetails: StrategyDetails): Promise<void> {
      return postTradeStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.message
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    saveStrategyData(strategyDetails: StrategyDetails) {
      this.tempStrategyData = strategyDetails
      router.push({ name: 'SummaryPage' })
    },
    saveTradeStrategyData(strategyDetails: StrategyDetails) {
      this.tempStrategyData = strategyDetails
      router.push({ name: 'TradeSummaryPage' })
    },
    saveTempMFStrategyData(strategyDetails: MutualFundDetails) {
      this.tempMFStrategyData = strategyDetails
      router.push({ name: 'MFSummaryPage' })
    },
    hideShowModalBasket(strategyId: string | string[]) {
      this.fetchBasketById(strategyId)
      this.showModal = false
    },
    hideTradeShowModalBasket(strategyId: string | string[]) {
      this.fetchTradeBasketById(strategyId)
      this.showModal = false
    },
    hideShowModalPosition(strategyId: string | string[]) {
      this.fetchPositionById(strategyId)
      this.showModal = false
    },
    hideTradeShowModalPosition(strategyId: string | string[]) {
      this.fetchTradePositionById(strategyId)
      this.showModal = false
    },
    closeEsignModal() {
      this.esignModal = false
    },
    hideShowModalTradeBasket(strategyId: string | string[]) {
      this.fetchTradeBasketById(strategyId)
      this.showModal = false
    },
    hideShowModalMFBasket(strategyId: string | string[]) {
      this.fetchMFBasketById(strategyId)
      this.showModal = false
    },
    hideErrorModal() {
      this.errorModal = false
    },
    hideShowModal() {
      this.showModal = false
    },
    hideTradeShowModal() {
      this.showModal = false
    },

    saveEditedStrategyDataTemp(strategyDetails: StrategyDetails): Promise<void> {
      return postEditedStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.message
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    saveEditedMFStrategyDataTemp(strategyDetails: MutualFundDetails): Promise<void> {
      return postEditedMFStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.data
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    saveMFStrategyData(strategyDetails: MutualFundDetails): Promise<void> {
      return saveMFStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.data
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    saveTradeEditedStrategyDataTemp(strategyDetails: StrategyDetails): Promise<void> {
      return postTradeEditedStrategyData(strategyDetails)
        .then((response: AxiosResponse) => {
          this.savedStrategyResponse = response?.data?.message
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
          this.esignModal = true
        })
    },
    saveEditedStrategyData(strategyDetails: StrategyDetails) {
      this.tempStrategyData = strategyDetails
      router.push({ name: 'SummaryPage', query: { pageType: 'EditPage' } })
    },
    saveEditedMFStrategyData(strategyDetails: MutualFundDetails) {
      this.tempMFStrategyData = strategyDetails
      router.push({ name: 'MFSummaryPage', query: { pageType: 'MFEditPage' } })
    },
    saveTradeEditedStrategyData(strategyDetails: StrategyDetails) {
      this.tempStrategyData = strategyDetails
      router.push({ name: 'TradeSummaryPage', query: { pageType: 'TradeEditPage' } })
    },
    statusEditMStrategy(id: string | undefined): Promise<void> {
      return statusEditMStrategy(id)
        .then((response: AxiosResponse) => {
          this.fetchStrategyData()
          this.fetchAllBBStrategies()
          this.savedStrategyResponse = response?.data?.message
          this.showModal = true
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    deleteUserStrategy(id: number): Promise<void> {
      return deleteStrategy(id)
        .then(() => {
          this.fetchStrategyData()
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    deleteUserBBStrategy(id: number): Promise<void> {
      return deleteBBStrategy(id)
        .then(() => {
          this.fetchAllBBStrategies()
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    deleteUserMFStrategy(id: number): Promise<void> {
      return deleteMFStrategy(id)
        .then(() => {
          this.fetchMFStrategyData()
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    deleteUserTradeStrategy(id: number): Promise<void> {
      return deleteTradeStrategy(id)
        .then(() => {
          this.fetchTradeStrategyData()
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    createStrategyCopy(id: number | undefined, name: string | undefined): Promise<void> {
      return createStrategyCopy(id, name)
        .then(() => {
          this.fetchStrategyData()
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchPredefinedGroups(): Promise<void> {
      return fetchPredefinedGroups()
        .then((response: AxiosResponse) => {
          this.groupsData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchMyGroups(): Promise<void> {
      return fetchMyGroups()
        .then((response: AxiosResponse) => {
          this.myGroupData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchMySystemBuilder(): Promise<void> {
      return fetchMySystemBuilder()
        .then((response) => {
          this.mySystemBuilder = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchPublicSystemBuilder(): Promise<void> {
      return fetchPublicSystemBuilder()
        .then((response) => {
          this.publicSystemBuilder = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchPredefinedSystemBuilder(): Promise<void> {
      return fetchPredefinedSystemBuilder()
        .then((response) => {
          this.predefinedSystemBuilder = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchStrategyById(strategyId: string | string[]): Promise<void> {
      return fetchStrategyById(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getStrategyDataById = null
          } else {
            this.getStrategyDataById = response?.data?.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFStrategyById(strategyId: string | string[]): Promise<void> {
      return fetchMFStrategyById(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getMFStrategyDataById = null
          } else {
            this.getMFStrategyDataById = response?.data?.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTradeStrategyById(strategyId: string | string[]): Promise<void> {
      return fetchTradeStrategyById(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getTradeStrategyDataById = []
          } else {
            // console.log('response.data', response.data)
            this.getTradeStrategyDataById = response?.data?.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchPopularStrategyData(strategyId: string): Promise<void> {
      return fetchPopularStrategyDataid(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getPopularStrategyDataById = []
          } else {
            this.getPopularStrategyDataById = response.data.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTPopularStrategyData(strategyId: string): Promise<void> {
      return fetchTPopularStrategyById(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getTradePopularStrategyDataById = []
          } else {
            this.getTradePopularStrategyDataById = response?.data?.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFPopularStrategyData(strategyId: string): Promise<void> {
      return fetchMFPopularStrategyById(strategyId)
        .then((response) => {
          if (response.data == null) {
            this.getMFPopularStrategyDataById = null
          } else {
            this.getMFPopularStrategyDataById = response.data.data
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchPositionById(strategyId: string | string[]): Promise<void> {
      return fetchPositionById(strategyId)
        .then((response) => {
          this.getPositionsById = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFPositionById(strategyId: string | string[]): Promise<void> {
      return fetchMFPositionById(strategyId)
        .then((response) => {
          const res = response.data.data as MFResponse
          this.getMFPositionsById = res.apiResponse[0].momentifyAvgBuyPriceBySchemeCodes
          this.getMFSchemes = res.schemeNames
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchClosedPositionById(strategyId: string | string[]): Promise<void> {
      return fetchClosedPositionById(strategyId)
        .then((response) => {
          this.closedPositionsById = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTradePositionById(strategyId: string | string[]): Promise<void> {
      return fetchTradePositionById(strategyId)
        .then((response) => {
          this.getTradePositionsById = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTradeClosedPositionById(strategyId: string | string[]): Promise<void> {
      this.closedTradePositionsById = {} as Positions[]
      return fetchTradeClosedPositionById(strategyId)
        .then((response) => {
          this.closedTradePositionsById = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchBasketById(strategyId: string | string[]): Promise<void> {
      return fetchBasketById(strategyId)
        .then((response) => {
          const res = response?.data?.data
          this.getBasketById = res.baskets
          this.isBasketVirtual = res.IsVirtual
          this.InProgress = res.InProgress
          this.DaysLeft = res.DaysLeft
          this.ExecStrat = res.ExecStrat
          this.Status = res.Status
          this.isSipAmount = res.IsSipAmount
          this.ADDEDSIPAMT = res.ADDEDSIPAMT
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    // executeBasketOrderById(basketId: number[]): Promise<void> {
    //   return executeBasketOrderById(basketId)
    //     .then((response) => {
    //       this.orderBookStatus = response?.data?.data
    //       if (this.orderBookStatus.errors.length > 0) {
    //         this.errorModal = true
    //       } else {
    //         this.showModal = true
    //       }
    //     })
    //     .catch((error: { message: string }) => {
    //       this.errorModal = true
    //       this.error.message = error.message
    //     })
    // },
    executeBasketOrderById(basketId: number[]): Promise<void> {
      console.log('Investing Basket Executing...')
      return executeBasketOrderById(basketId)
        .then((response) => {
          const res = response?.data

          if (res?.isCustomException) {
            // this.errorModal = true
            this.error.message = res.message
            return
          }

          this.orderBookStatus = res?.data

          if (this.orderBookStatus?.errors?.length > 0) {
            this.errorModal = true
          } else {
            this.showModal = true
          }
        })
        .catch((error: unknown) => {
          const err = error as AxiosError<{ message?: string; isCustomException?: boolean }>

          if (err.response?.data?.isCustomException) {
            this.errorModal = true
            this.error.message = err.response.data.message || ''
            return
          }

          this.errorModal = true
          this.error.message = err.message || 'Something went wrong'
        })
    },
    cancelBasketOrderById(basketId: number[], strategyId: string | string[]): Promise<void> {
      return cancelBasketOrderById(basketId)
        .then((response) => {
          this.fetchBasketById(strategyId)
          this.executeBasketStatus = response.data.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    cancelTradeBasketOrderById(basketId: number[], strategyId: string | string[]): Promise<void> {
      return cancelTradeBasketOrderById(basketId)
        .then((response) => {
          this.fetchTradeBasketById(strategyId)
          this.executeBasketStatus = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    setEditId(id: number) {
      this.editId = id
    },
    forceRebalanceById(basketId: string | string[], isSipAmount: boolean): Promise<void> {
      return forceRebalanceById(basketId, isSipAmount)
        .then((response) => {
          console.log('response.data', response.data)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchRadarData(): Promise<void> {
      return fetchRadarData()
        .then((response) => {
          this.radarGroupData = response.data.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    sellPosition(id: number, strategyId: string | string[]): Promise<void> {
      return sellPosition(id)
        .then((response) => {
          this.fetchPositionById(strategyId)
          this.positionBookStatus = response?.data?.data
          if (this.positionBookStatus.isTradingDay == false) {
            this.errorModal = true
          } else {
            this.showModal = true
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    sellMFPosition(selectedScheme: string, selectedUnits: number): Promise<void> {
      return sellMFPosition(selectedScheme, selectedUnits)
        .then((response) => {
          this.showModal = true
          console.log(response.data)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.errorModal = true
        })
    },
    sellTradePosition(id: number, strategyId: string | string[]): Promise<void> {
      return sellTradePosition(id)
        .then((response) => {
          this.fetchTradePositionById(strategyId)
          this.positionBookStatus = response.data.data
          if (this.positionBookStatus.isTradingDay == false) {
            this.errorModal = true
          } else {
            this.showModal = true
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },

    markAsSellPosition(
      adjustPosition: AdjustPosition,
      strategyId: string | string[]
    ): Promise<void> {
      return markAsSellPosition(adjustPosition, strategyId)
        .then(() => {
          this.fetchPositionById(strategyId)
          this.checkPortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    markAsSellTradePosition(
      adjustPosition: AdjustPosition,
      strategyId: string | string[]
    ): Promise<void> {
      return markAsSellTradePosition(adjustPosition, strategyId)
        .then(() => {
          this.fetchTradePositionById(strategyId)
          this.checkTradePortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    addPosition(addPosition: AddPosition, strategyId: string | string[]): Promise<void> {
      return addPositions(addPosition)
        .then(() => {
          this.fetchPositionById(strategyId)
          this.checkPortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    addMultiplePositions(
      positions: Array<{ symbol: string; qty: number; price: number }>,
      strategyId: string | string[]
    ): Promise<void> {
      return addMultiplePositions(positions, strategyId)
        .then(() => {
          this.fetchPositionById(strategyId)
          this.checkPortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    addTradePosition(addPosition: AddPosition, strategyId: string | string[]): Promise<void> {
      return addTradePositions(addPosition)
        .then(() => {
          this.fetchTradePositionById(strategyId)
          this.checkTradePortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    addMultipleTradePositions(
      positions: Array<{ symbol: string; qty: number; price: number }>,
      strategyId: string | string[]
    ): Promise<void> {
      return addMultipleTradePositions(positions, strategyId)
        .then(() => {
          this.fetchTradePositionById(strategyId)
          this.checkTradePortfolioStatus(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    getMargin(): Promise<void> {
      return getMargin()
        .then((response) => {
          this.basketMargin = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },

    logoutSession(): Promise<void> {
      return logoutSession()
        .then((response) => {
          if (response.status == 200) {
            const baseUrl = import.meta.env.VITE_ENDPOINT_URL?.toString()
            window.location.href = `${baseUrl}/ssologin`
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    checkPortfolioStatus(strategyId: string | string[]): Promise<void> {
      return checkPortfolioStatus(strategyId)
        .then((response) => {
          this.portfolioResponse = response.data.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    checkTradePortfolioStatus(strategyId: string | string[]): Promise<void> {
      return checkTradePortfolioStatus(strategyId)
        .then((response) => {
          this.tradePortfolioResponse = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    calculateRealizedAndUnRealizedPNL(strategyId: number): Promise<void> {
      return calculateRealizedAndUnRealizedPNL(strategyId)
        .then((response) => {
          this.pnlResponse = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    calculateTradeRealizedAndUnRealizedPNL(strategyId: number | undefined): Promise<void> {
      return calculateTradeRealizedAndUnRealizedPNL(strategyId)
        .then((response) => {
          this.tradePnlResponse = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchStrategyNames(): Promise<void> {
      return fetchStrategyNames()
        .then((response) => {
          console.log('response.data in fetchStrategyNames', response.data)
          this.strategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTradeStrategyNames(): Promise<void> {
      return fetchTradeStrategyNames()
        .then((response) => {
          this.tradeStrategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFStrategyNames(): Promise<void> {
      return fetchMFStrategyNames()
        .then((response) => {
          this.mfStrategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchScannerList(): Promise<void> {
      return getScannersList()
        .then((response) => {
          this.scannersList = response.data.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    // fetchStrategyList(code: string): Promise<void> {
    //   this.filteredStrategies = {} as FilteredScannerList[]
    //   return getStrategyList()
    //     .then((response) => {
    //       this.filteredStrategies = response.data
    //     })
    //     .catch((error: { message: string }) => {
    //       this.error.message = error.message
    //     })
    // },
    fetchStrategyFromCode(code: string): Promise<void> {
      this.filteredStrategies = {} as FilteredScannerList[]
      return fetchStrategyFromCode(code)
        .then((response) => {
          this.filteredStrategies = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchFromConfigTable(): Promise<void> {
      return fetchFromConfigTable()
        .then((response) => {
          this.etfGroup = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    checkPlanPref(): Promise<void> {
      return checkPlanPref()
        .then((response) => {
          this.planPref = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchPopularStrategyNames(): Promise<void> {
      return fetchPopularStrategyNames()
        .then((response) => {
          console.log('Popular Strategy Names:', response.data)
          this.popularStrategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchPopularStrategiesByCategory(tag: string): Promise<void> {
      this.categoryLoading = true
      this.categoryStrategies = []
      return fetchPopularStrategiesByCategory(tag)
        .then((response) => {
          this.categoryStrategies = response?.data?.data ?? []
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.categoryStrategies = []
        })
        .finally(() => {
          this.categoryLoading = false
        })
    },
    fetchTopPerformerStrategies(): Promise<void> {
      this.topPerformerLoading = true
      this.topPerformerStrategies = []
      return fetchTopPerformerStrategies()
        .then((response) => {
          this.topPerformerStrategies = response?.data?.data ?? []
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.topPerformerStrategies = []
        })
        .finally(() => {
          this.topPerformerLoading = false
        })
    },
    fetchTradingPopularStrategyNames(): Promise<void> {
      return fetchTradingPopularStrategyNames()
        .then((response) => {
          this.popularTradeStrategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFPopularStrategyNames(): Promise<void> {
      return fetchMFPopularStrategyNames()
        .then((response) => {
          this.popularMFStrategyNames = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    confirmAdjustHoldings(strategyId: string | string[], id: number, qty: number, price: number) {
      return confirmAdjustHoldings(id, qty, price)
        .then(() => {
          this.fetchPositionById(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    confirmAdjustClosedPositions(
      strategyId: string | string[],
      id: number,
      bqty: number,
      bprice: number,
      sqty: number,
      sprice: number
    ) {
      return confirmAdjustClosedPositions(id, bqty, bprice, sqty, sprice)
        .then(() => {
          this.fetchClosedPositionById(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    confirmAdjustTradeHoldings(
      strategyId: string | string[],
      id: number,
      qty: number,
      price: number
    ) {
      return confirmAdjustTradeHoldings(id, qty, price)
        .then(() => {
          this.fetchTradePositionById(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    confirmAdjustTradeClosedPositions(
      strategyId: string | string[],
      id: number,
      bqty: number,
      bprice: number,
      sqty: number,
      sprice: number
    ) {
      return confirmAdjustTradeClosedPositions(id, bqty, bprice, sqty, sprice)
        .then(() => {
          this.fetchTradeClosedPositionById(strategyId)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchLogsData(strategyId: string | string[]): Promise<void> {
      return fetchLogData(strategyId)
        .then((response) => {
          this.logs = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchAuditLogData(strategyId: string | string[]): Promise<void> {
      return fetchAuditLogData(strategyId)
        .then((response) => {
          this.auditlogs = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchHsToken(): Promise<void> {
      return fetchHsToken()
        .then((response) => {
          this.hsToken = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },

    fetchPoaStatus(): Promise<void> {
      return fetchPoaStatus()
        .then((response) => {
          this.poaStatus = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchNseSector(): Promise<void> {
      return fetchNseSector()
        .then((response) => {
          this.nseSectorResponse = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchNseRate(symParam: string, givenDate: string | undefined): Promise<void> {
      return fetchNseRate(symParam, givenDate)
        .then((response) => {
          this.nseSectorRate = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchMFBasketById(strategyId: string | string[]): Promise<void> {
      return fetchMFBasketById(strategyId)
        .then((response) => {
          this.mfBasket = response?.data?.data.baskets
          this.TradeInProgress = response.data.data.InProgress
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchTradeBasketById(strategyId: string | string[]): Promise<void> {
      return fetchTradeBasketById(strategyId)
        .then((response) => {
          this.tradeBasket = response?.data?.data.baskets
          this.TradeInProgress = response?.data?.data.InProgress
          this.TradeExecStrat = response?.data?.data.OpenExecStat
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    forceRebalanceTradeBasket(basketId: string | string[]): Promise<void> {
      return forceRebalanceTradeBasket(basketId)
        .then((response) => {
          console.log('response.data', response?.data)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    forceRebalanceMFBasket(basketId: string | string[]): Promise<void> {
      return forceRebalanceMFBasket(basketId)
        .then((response) => {
          console.log('response.data', response?.data)
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    executeBasketTrades(id: number[], buzzarAlert: boolean): Promise<void> {
      return executeBasketTrades(id, buzzarAlert)
        .then((response) => {
          const combinedOrderResponse = response?.data?.data
          this.orderBookStatus = combinedOrderResponse

          const errors = Array.isArray(combinedOrderResponse?.errors)
            ? combinedOrderResponse.errors
            : []

          if (errors.length > 0) {
            this.errorModal = true
          } else {
            this.showModal = true
          }
        })
        .catch((error: { message: string }) => {
          this.errorModal = true
          this.error.message = error.message
        })
    },
    executeMFBasketTrades(id: number[]): Promise<void> {
      return executeMFBasketTrades(id)
        .then((response) => {
          console.log('response--->', response)

          this.mfStatus = response?.data?.data

          this.mfMessage = this.mfStatus?.data || ''

          if (this.mfStatus.errors?.length) {
            this.errorModal = true
          } else {
            this.showModal = true
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    calculateCurrentValue(id: string | string[]): Promise<void> {
      return calculateCurrentValue(id)
        .then((response) => {
          this.currentValue = 0
          this.currentValue = response?.data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchSymbolsDataCron(): Promise<void> {
      return fetchNSESymbolsCron()
        .then((response: AxiosResponse) => {
          this.symbolsData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchSymbolsDataCronWithBe(name: string, type: string): Promise<void> {
      return fetchSymbolsDataCronWithBe(name, type)
        .then((response: AxiosResponse) => {
          this.symbolsData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    async fetchStrategyName(code: number): Promise<{ scannercode: string; strategyid: number }> {
      try {
        const response: AxiosResponse = await fetchStrategyNameFromCode(code)
        return response?.data.data
      } catch (error) {
        const err = error as AxiosError
        this.error.message = err.message
        return { scannercode: '', strategyid: 0 }
      }
    },
    checkForValidRole(): Promise<void> {
      return checkForValidRole()
        .then((response: AxiosResponse) => {
          this.isValidRole = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    eSign(): Promise<void> {
      return eSign()
        .then((response) => {
          console.log('response.data', response?.data)
          window.location.href = response.data.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    getSimulatorResult(payload: SimulatorPayload): Promise<SimulatorResponse | null> {
      return getSimulatorResult(payload)
        .then((response) => {
          if (response.data == null) {
            this.simulatorResult = null
            return this.simulatorResult
          } else {
            this.simulatorResult = response?.data?.data
            return this.simulatorResult
          }
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          throw error
        })
    },
    getBacktestingResult(payload: BacktestingPayload): Promise<BackTestResult[]> {
      return getBacktestingResult(payload)
        .then((data) => {
          // console.log('Response ', data)

          this.backtestResult = data?.data ?? []
          return this.backtestResult
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          return []
        })
    },
    fetchBlackboxStrategyDataById(id: number) {
      return fetchBlackboxStrategyDataById(id)
        .then((data) => {
          this.getBBStrategyDataById = data?.data ?? []
          return this.getBBStrategyDataById
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          return []
        })
    },
    validateBlackboxStrategyDataById(name: string, id: number) {
      return validateBlackboxStrategyDataById(name, id)
        .then((data) => {
          return data?.data
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          return false
        })
    },
    fetchWPMomentumAll(): Promise<WpPost[]> {
      return fetchWPMomentumAll()
        .then((response) => {
          const data = response?.data?.data

          if (Array.isArray(data)) {
            this.wpMomentumAll = data
          } else {
            this.wpMomentumAll = []
          }

          return this.wpMomentumAll
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.wpMomentumAll = []
          return []
        })
    },
    fetchWPStrategies(): Promise<CachedStrategyItem[]> {
      return fetchWPStrategies()
        .then((response) => {
          const data = response?.data?.data

          if (Array.isArray(data)) {
            this.wpStrategies = data
          } else {
            this.wpStrategies = []
          }
          return this.wpStrategies
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.wpStrategies = []
          return []
        })
    },
    fetchBlackboxStrategyData(): Promise<void> {
      return fetchBBStrategies()
        .then((response: AxiosResponse) => {
          this.getBBStrategyData = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },
    fetchHoldings(type: string): Promise<void> {
      this.holdingsLoading = true
      this.holdingsError = null

      return getHoldings(type)
        .then((response: IHoldingsApiResponse): void => {
          if (response?.statusCode === 200 && response?.data) {
            const holdingsData: IHoldingsApiItem[] = Array.isArray(response.data)
              ? response.data
              : []

            this.holdings = holdingsData.map((item: IHoldingsApiItem): IHolding => {
              const qty = parseInt(String(item.qty || item.holdqty || 0))
              const price = parseFloat(String(item.upldprc || item.avgprice || item.price || 0))

              return {
                id: String(item.token || item.id || ''),
                symbol: String(item.defSym || item.symbol || item.tsym || ''),
                heldQty: qty,
                buyPrice: price,
                value: qty * price,
                maxAvailableQty: parseInt(String(item.qty || item.holdqty || item.heldQty || 0))
              }
            })
          } else {
            this.holdings = []
            console.warn('[fetchHoldings] Invalid response structure')
          }

          this.holdingsLoading = false
        })
        .catch((error): void => {
          this.holdingsError =
            error.response?.data?.message || error.message || 'Failed to fetch holdings'
          this.holdingsLoading = false
          console.error('[fetchHoldings] Error:', this.holdingsError)
          throw error
        })
    },

    fetchAllBBStrategies(): Promise<void> {
      return fetchAllBBStrategies()
        .then((response: AxiosResponse) => {
          this.allBBStrategies = response?.data?.data
        })
        .catch((error) => {
          this.error.message = error.message
        })
    },

    clearHoldings() {
      this.holdings = []
      this.holdingsError = null
    },
    fetchMmmScore(): Promise<void> {
      return fetchMmmScore()
        .then((response) => {
          this.mmmScoreData = response?.data?.data ?? {}
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
        })
    },
    fetchAvailableTags(): Promise<void> {
      return fetchAvailableTags()
        .then((response) => {
          this.availableTags = response?.data?.data ?? []
        })
        .catch((error: { message: string }) => {
          this.error.message = error.message
          this.availableTags = []
        })
    }
  }
})
